import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { applyDocumentTheme, applyPublicLightTheme } from '@/lib/theme'
import { syncDocumentLangFromSettings } from '@/i18n/useUiLocale'
import type { UserSettings } from '@/types/settings'

interface SettingsState {
  theme: 'light' | 'dark'
  settings: UserSettings | null
  setSettings: (settings: UserSettings) => void
  setTheme: (theme: 'light' | 'dark') => void
  clearSettings: () => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      theme: 'light',
      settings: null,
      setSettings: (settings) => {
        applyDocumentTheme(settings.theme)
        syncDocumentLangFromSettings(settings.uiLanguage)
        set({ settings, theme: settings.theme })
      },
      setTheme: (theme) => {
        applyDocumentTheme(theme)
        set((state) => ({
          theme,
          settings: state.settings ? { ...state.settings, theme } : state.settings,
        }))
      },
      clearSettings: () => {
        applyPublicLightTheme()
        set({ settings: null, theme: 'light' })
      },
    }),
    {
      name: 'lexio-settings',
      partialize: (state) => ({ theme: state.theme }),
    }
  )
)
